import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PricingRuleList from "./PricingRuleList";
import PricingRuleForm from "./PricingRuleForm/PricingRuleForm";
import PricingRuleDetails from "./PricingRuleDetails";

export const AdminPricingRoutes = () => {
  return (
    <Routes>
      {/* Default list */}
      <Route index element={<PricingRuleList />} />

      {/* ===== FILTERED VIEWS (must come before :id routes) ===== */}
      <Route path="list" element={<PricingRuleList />} />
      <Route path="active" element={<PricingRuleList filter="active" />} />
      <Route path="inactive" element={<PricingRuleList filter="inactive" />} />
      <Route path="priority" element={<PricingRuleList filter="priority" />} />
      <Route path="expired" element={<PricingRuleList filter="expired" />} />
      <Route
        path="scheduled"
        element={<PricingRuleList filter="scheduled" />}
      />

      {/* Product type filters */}
      <Route path="gold" element={<PricingRuleList filter="gold" />} />
      <Route path="silver" element={<PricingRuleList filter="silver" />} />
      <Route path="diamond" element={<PricingRuleList filter="diamond" />} />
      <Route path="platinum" element={<PricingRuleList filter="platinum" />} />

      {/* Branch filter */}
      <Route
        path="branch/:branchCode"
        element={<PricingRuleList filter="branch" />}
      />

      {/* Search */}
      <Route path="search" element={<PricingRuleList filter="search" />} />

      {/* ===== ACTIONS (must come before :id routes) ===== */}
      <Route path="new" element={<PricingRuleForm mode="add" />} />

      {/* ===== DYNAMIC ROUTES (must come last) ===== */}
      <Route path=":id" element={<PricingRuleDetails />} />
      <Route path=":id/edit" element={<PricingRuleForm mode="edit" />} />
      <Route path=":id/clone" element={<PricingRuleForm mode="clone" />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/pricing-rules" replace />} />
    </Routes>
  );
};

export default AdminPricingRoutes;
